import type { FaireProductEntity } from "../../entity_types/product";

export const p_6czakg06he: FaireProductEntity = {
  token: "p_6czakg06he",
  type: "product",
  name: "Sky's the Limit Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/00d7a8b6a9370e722d79c8ad1cee92701e97a0f591c9cf32f7cad9b85fc52c7c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5b0a82cadd6bb88bb6f83d8c3085de14a4aabcf18f825e283d3c2ed6a3c4fc6.png",
    "https://cdn.faire.com/fastly/2e94d549a13ab1c695f49d8ecda3e3d5093891f1b489603de5b05339a65a1e75.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:26.956Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
